// CGPA Zone mapping with colors and descriptions
export const CGPA_ZONES = {
  '<6': {
    name: 'Danger Zone',
    dotColor: '#ef4444',
    bgClass: 'bg-red-50',
    borderClass: 'border-red-300',
    textClass: 'text-red-700',
    description:
      'Your CGPA is below placement eligibility. Focus on your Academics, Study 2-3 hrs daily, Focus on scoring subjects to improve your standing.',
  },
  '6-7': {
    name: 'Survival Zone',
    dotColor: '#f97316',
    bgClass: 'bg-orange-50',
    borderClass: 'border-orange-300',
    textClass: 'text-orange-700',
    description:
      'You are eligible but not competitive. You can improve and get better CGPA. Start focusing on maximising marks and building strong fundamentals.',
  },
  '7-8': {
    name: 'Safe Zone',
    dotColor: '#eab308',
    bgClass: 'bg-yellow-50',
    borderClass: 'border-yellow-300',
    textClass: 'text-yellow-700',
    description:
      'Your CGPA is good. Start serious placement preparation. Practice aptitude daily, Build 1-2 projects, Start skill focus to stand out.',
  },
  '8-9': {
    name: 'Advantage Zone',
    dotColor: '#22c55e',
    bgClass: 'bg-green-50',
    borderClass: 'border-green-300',
    textClass: 'text-green-700',
    description:
      'You have an advantage over others. Focus on converting it into a job, Maintain CGPA, Build strong projects, Prepare interviews and crack top companies.',
  },
  '9+': {
    name: 'Top Tier',
    dotColor: '#3b82f6',
    bgClass: 'bg-blue-50',
    borderClass: 'border-blue-300',
    textClass: 'text-blue-700',
    description:
      'You are in top tier. Aim for top companies. Target high packages, Advanced projects and leadership roles to maximise your potential.',
  },
};

export const getCgpaZone = (range) => CGPA_ZONES[range] || null;
